import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '@bidi/common-services';

@Component({
  selector: 'bidi-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {
  avatarSelectorOpen = false;
  achievementsOpen = false;
  configurationOpen = false;
  userFileOpen = false;

  profileMenu = [
    {
      name: 'Configuracion',
      icon: 'icon-ticmas-icon-config',
      href: '#icon-ticmas-icon-config'
    }
  ];

  @Output() saveImg = new EventEmitter<any>();
  @Input() user: any;
  @Input() avatar: string;
  objImg: any;
  editPro = false;

  constructor (private auth: AuthService) {
  }

  searchImg (event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = ({ target }: ProgressEvent) => {
        this.avatar = (<FileReader>target).result.toString();
      };
      reader.readAsDataURL(event.target.files[0]);
      this.objImg = event.target.files[0];
    }
  }

  editProfile () {
    this.editPro = true;
  }

  saveProfile () {
    this.editPro = false;
    this.saveImg.emit(this.objImg);
  }

  openAvatarSelector () {
    this.avatarSelectorOpen = true;
  }

  closeAvatarSelector (state) {
    this.avatarSelectorOpen = state;
  }

  openMenuPanel (panel) {
    if (panel === 'Configuracion') {
      this.configurationOpen = true;
    }
  }

  closePanel (event) {
    if (event.panel === 'Configuracion') {
      this.configurationOpen = event.state;
    }
  }

  logOut () {
    this.auth.keycloakService.logout();
  }
}
